import styled from 'styled-components';

export const FavoritesButtonStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .icon {
    margin-right: 4px;
    margin-bottom: -2px;

    &.loading {
      animation: spin 0.5s linear infinite;

      @keyframes spin {
        100% {
          transform: rotate(360deg);
        }
      }
    }
  }

  &:not(.on-truck-page) {
    @media screen and (max-width: 638px) {
      padding: 5px;
      border-radius: 50%;

      .text {
        display: none;
      }

      .icon {
        margin: 0;
      }
    }
  }

  &.mobile {
    box-sizing: border-box;
    border-radius: 50%;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
    background-color: ${({ theme }) => theme.colors.color_white};
    width: 40px;
    height: 40px;
    padding: 8px;

    .icon {
      width: 100%;
      height: 100%;
    }

    //.icon.add {
    //  transform: rotate(0deg);
    //  transition: all 0.1s;
    //}
    //
    //.icon.added {
    //  transform: rotate(360deg);
    //  transition: all 0.1s;
    //}
  }
`;
